// extracted by mini-css-extract-plugin
export default {"Tags":"index-module--Tags--g6zbg","Tags__list":"index-module--Tags__list--Z-sNY","Tags__item":"index-module--Tags__item--IAOlX"};